import styled from 'styled-components'

export const Header = styled.header`
display: flex;
justify-content: space-between;
align-items: center;
position: sticky;
top: 0;
left: 0;
right: 0;
height: ${(props) => (props.isScrolled ? "15vh" : "16.5vh")};
background-color: #ffffff;
box-shadow: ${(props) => (props.isScrolled ? "0 4px 20px rgba(0,0,0,0.1)" : "none")};
transition: all 0.3s ease;
z-index: 1;
@media (min-width: 201px) and (max-width: 500px) {
  height: ${(props) => (props.isScrolled ? "12vh" : "13.5vh")};
}
`
export const Img = styled.img`
width: 6vw;
position: relative;
left: 1rem;
margin-top: 0.5rem;
cursor: pointer;
@media (min-width: 201px) and (max-width: 500px) {
width: 15vw;
left: 0.5rem;
}
@media (min-width: 501px) and (max-width: 900px) {
 width: 10vw;
left: 0.5rem;
}
`
export const Nav = styled.nav`
width: 50%;
@media (min-width: 201px) and (max-width: 500px) {
display: none;
}
@media (min-width: 501px) and (max-width: 900px) {
display: none;
}
`
export const Ul = styled.ul`
list-style: none;
display: flex;
justify-content: space-evenly;
:hover {
    text-shadow: 1px 1px 2px;
    transition: 0.2s;
}
.active {
  text-shadow: 1px 1px 2px;
}
.active:hover {
  text-shadow: 2px 2px 3px;
    transition: 0.2s;
}
`
export const Li = styled.li`
font-size: 1.25rem;
cursor: pointer;
transition: 0.2s;
a {
  text-decoration: none;
  color: black;
  transition: 0.2s;
}
@media (min-width: 901px) and (max-width: 1250px) {
  font-size: 1.25rem;
}
`
export const A = styled.a `
background-color: #FFEB3B;
text-align: center;
padding-top: 0.5rem;
position: relative;
right: 1rem;
cursor: pointer;
text-decoration: none;
text-align: center;
width: 10%;
height: 7vh;
border-radius: 5px;
@media (min-width: 201px) and (max-width: 500px) {
  height: 5vh;
  width: 25%;
  margin-left: 1rem;
}
@media (min-width: 501px) and (max-width: 900px) {
height: 4vh;
width: 15%;
}
`
export const Button = styled.button`
border: none;
font-size: 1.5rem;
background-color: transparent;
cursor: pointer;
color: #323232;
@media (min-width: 201px) and (max-width: 500px) {
font-size: 1.1rem;
}
@media (min-width: 901px) and (max-width: 1300px) {
    font-size: 1.25rem;
}
`
export const DivMobile = styled.div`
display: none;
position: relative;
padding: 10px;
color: white;
@media (min-width: 201px) and (max-width: 500px) {
display: block;
}
@media (min-width: 501px) and (max-width: 900px) {
display: block;
}
`
export const ButtonMobile = styled.button`
border: none;
background-color: transparent;
cursor: pointer;
font-size: 1.5rem;
@media (min-width: 501px) and (max-width: 900px) {
font-size: 2.5rem;
}
`
export const NavMobile = styled.nav`
background-color: #fff36a;
width: 100vw;
overflow: hidden;
max-height: 0px;
transition: max-height 0.1s ease-in;
font-size: 1.3rem;
position: absolute;
z-index: 1;
right: 0.2rem;
margin-top: 0.5rem;
@media (min-width: 501px) and (max-width: 900px) {
font-size: 1.5rem;
width: 35vw;
}

`
export const UlMobile = styled.ul`
list-style: none;
hr {
  opacity: 0.2;
  color: white;
  width: 95%;
  margin-left: 0.5rem;
  text-decoration: none;
}
`
export const LiMobile = styled.li`
text-align: center;
`
export const aMobile = styled.a`
color: black;
padding: 14px 20px;
text-decoration: none;
display: block;
a {
  color: black;
  text-decoration: none;
}
`